(function () {
  "use strict";

  GroupDetailSidebarCtrl.$inject = ['$scope', 'groupsResource', '$location', '$window', 'compositeSearchData', 'sortHelper', 'trainerPrivilege', 'accountFeatures', 'mtypes'];
  angular
    .module('trainerWebApp.controllers')
    .controller('GroupDetailSidebarCtrl', GroupDetailSidebarCtrl);

  function GroupDetailSidebarCtrl($scope, groupsResource, $location, $window, compositeSearchData, sortHelper, trainerPrivilege, accountFeatures, mtypes) {

    var userRole = trainerPrivilege.roles();

    $scope.canEditGroups = userRole.canEditGroups;
    $scope.canEditGroupMembership = userRole.canEditGroupMembership;
    $scope.canDelete = !mfConfig.useGroupRestrictions && $scope.canEditGroups;

    $scope.$watch('selectedGroup', function () {
      if (!$scope.selectedGroup) {
        return;
      }
      $scope.selectedGroup.groupUsers = [];
      if ($scope.selectedGroup.userCount > 0 || $scope.viewModel.showTrainerPermissions) {
        setup($scope.selectedGroup.id);
      }
    });

    function setup(groupId) {
      groupsResource.getGroupUsers(groupId, function (result) {
        _.each(result, function (user) {
          user.name = user.lastName + ', ' + user.firstName;
        });

        if (!$scope.selectedGroup) {
          return;
        }

        $scope.selectedGroup.groupUsers = result.sort(sortHelper.getStringPropertySorter({
          field: 'lastName',
          asc: true
        }));
      });

      if ($scope.viewModel.showTrainerPermissions) {
        groupsResource.getGroupTrainers(function (result) {

          if (!$scope.selectedGroup) {
            return;
          }

          _.each(result.allGroupTrainers, function (trainer) {
            trainer.name = trainer.lastName + ', ' + trainer.firstName;
            trainer.groupRestriction = false;
          });
          _.each(result.allRestrictedTrainers, function (trainer) {
            trainer.name = trainer.lastName + ', ' + trainer.firstName;
            trainer.groupRestriction = true;
          });
          $scope.selectedGroup.allTrainers = result.allGroupTrainers;
          $scope.selectedGroup.allTrainersCount = $scope.selectedGroup.allTrainers.length;
          $scope.selectedGroup.allRestrictedTrainers = result.allRestrictedTrainers;

          $scope.selectedGroup.groupTrainers = _.filter(result.allRestrictedTrainers, function (group) {
            return group.groupId == $scope.selectedGroup.id;
          });

          var trainerGroupRestrictionCount = _.countBy(result.allRestrictedTrainers, function (group) {
            return group.id;
          });

          _.each($scope.selectedGroup.groupTrainers, function (groupTrainer) {
            groupTrainer.numOfGroupRestricted = _.filter(trainerGroupRestrictionCount, function (num, key) {
              if (groupTrainer.id == key) return num;
            });
          });

          $scope.selectedGroup.groupTrainersCount = $scope.selectedGroup.groupTrainers.length;
        });
      }
    }

    $scope.filterByUser = function (user) {
      compositeSearchData.setSearchData('user', user.id);

      var hasManageUsersMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.manageUsersMontara);
      if (hasManageUsersMontaraFeature)
        $window.location.href = '/TrainerM/#/ManageUsers';
      else
        $location.path('/TMS/ManageUsers');
    };

    function showDeleteConfirmation(item) {
      item.numOfUniqueTrainer = 0;
      _.each(item.groupTrainers, function (groupTrainer) {
        if (groupTrainer.numOfGroupRestricted[0] == 1)
          item.numOfUniqueTrainer++;
      });

      $scope.$broadcast('deleteGroupEvent', item);
    }

    $scope.deleteGroup = function (item) {
      if (!$scope.canDelete) {
        return;
      }


      if (!item.id) {
        item.deleted = true;
        $scope.refreshData();
        return;
      }

      if (item.userCount > 0) {
        item.deleted = true;
        return showDeleteConfirmation(item);
      } else {
        doDelete(item.id);
        item.deleted = true;
        return true;
      }
    };

    $scope.$on('deleteGroupConfirmEvent', function (event, groupId, cb) {
      event.stopPropagation();
      doDelete(groupId, cb);
    });

    function doDelete(id, cb) {
      groupsResource.deleteGroup(id, function () {
        (cb || angular.noop)();
        $scope.refreshData();
        $scope.proceedWithSidebarCollapse();
      });
      $scope.selectedGroup.deleted = true;
    }

    $scope.editGroupName = function () {
      $scope.changeSidebar('pages/group/editGroupNameSidebar.html');
    };

    $scope.editGroupUsers = function () {
      $scope.changeSidebar('pages/group/editGroupUsersSidebar.html');
    };

    $scope.editGroupTrainers = function () {
      $scope.changeSidebar('pages/group/editGroupTrainersSidebar.html');
    };
  }

})();
